import React, { Suspense } from 'react';
import { withRouter } from "react-router-dom";
import ScrollAnimation from 'react-animate-on-scroll';
import { Trans, useTranslation } from 'react-i18next';
import SecondImage from '../../assets/images/bizdocs_devices.png';
import FirstImage from '../../assets/images/digitalArchiveLP.png';
import ListImage from '../../assets/images/list.png';
import { CardsBox } from '../../components/CardsBox/CardsBox';
import Header from '../../components/Header/Header';
import GreenButton from '../../components/shared/GreenButton/GreenButtonNormalLink';
import DesktopFooter from '../../components/shared/DesktopFooter/DesktopFooterLandingPageG';
import Loader from '../../components/shared/Loader/Loader';
import MobileFooter from '../../components/shared/MobileFooter/MobileFooterLandingPage';
import TextCheck from '../../components/shared/TextCheck/SmallTextCheck';
import Testimonials from '../../components/Testimonials/Testimonials2';
import GlobalStyles from '../../global.styles';
import { cards } from './cardsContent';
import { BigGreenBox, ContentBox, ContentCenterBox, Image, BigImage, ImageBox, ImgBox, ImgMobileBox, MarginBox, OtherContentBox, StripCenter, StripLeft, StripRight, SubContentBox, TextContent, Title, SubTitle, TitleLabel } from './DigitalArchive.style';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import BookDemoButton from '../../components/shared/BookDemoButton/BookDemoButton';
import BizIcon from '../../assets/images/bizIcon.png';
import PC1 from '../../assets/images/pc1.png';
import PC2 from '../../assets/images/pc2.png';
import PC3 from '../../assets/images/pc3.png';
import { ReactComponent as BizdocsDown } from '../../assets/images/Bizdocs_down.svg';
import { ReactComponent as SageIcon1 } from '../../assets/images/sageIcon1.svg';
import { ReactComponent as SageIcon2 } from '../../assets/images/sageIcon2.svg';
import { ReactComponent as SageIcon3 } from '../../assets/images/sageIcon3.svg';
import { ReactComponent as SageIcon4 } from '../../assets/images/sageIcon4.svg';
import { ReactComponent as SageIcon5 } from '../../assets/images/sageIcon5.svg';
import { ReactComponent as SageIcon6 } from '../../assets/images/sageIcon6.svg';
import Sage from '../../assets/images/Sage.png';
import CarouselSlider from '../../components/CarouselSlider/CarouselSlider';


const DigitalArchiveConst = withRouter(({ history }) => {
    //const history = useHistory();
    //const { t } = useTranslation();

    //const [showBox, setShowBox] = React.useState(false);
    //const openBox = () => setShowBox(true);

    const [show, setShow] = React.useState(false);
    const [showForm, setShowForm] = React.useState(false);

    const handleClose = () => {
        setShowForm(false)
        setShow(false)
    };
    const handleShow = () => setShow(true);
    const toggleNext = () => setShowForm(true);

    const expand = () => {
        document.getElementById("greenBoxContent").classList.remove("d-none");
        document.getElementById("greenBoxContent").classList.add("ease-out");
    }

    const sendEmailForm = async () => {

        let isFormValid = document.getElementById("bookForm").reportValidity();

        if (!isFormValid)
            return;

        await fetch('/welcome/api/Emails/demo/Banner', {
        //await fetch('/api/Emails/demo/Banner', {
            method: "POST",
            body: JSON.stringify({
                name: document.getElementById("demoName").value,
                email: document.getElementById("demoEmail").value,
                phoneNumber: document.getElementById("demoTelemovel").value,
                company: document.getElementById("demoEmpresa").value,
                software: document.getElementById("demoSoftware").value
            }),
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
        }).then(res => res.json()).then(
            (result) => {
                //toggleNext();
                window.sourcePage = "Banner";
                history.push("/thank-you");
            },
            (error) => {

            }
        )
    };

    return (
        <>
            <GlobalStyles />

            <Modal show={show} size="lg" onHide={handleClose}>
                <form id="bookForm">
                    <Modal.Header closeButton>

                        <Modal.Title className="w-100 text-center"><h1 style={{ color: "#6CB93D", fontSize: "26px" }}>Quero marcar uma demonstração</h1></Modal.Title>

                        {/*<Modal.Title className={(!showForm) ? "d-none" : "w-100 text-center"}><h1 style={{ color: "#6CB93D", fontSize: "26px" }}>Muito obrigado!</h1></Modal.Title>*/}
                    </Modal.Header>
                    <Modal.Body>
                        {/*<SubTitle className={showForm ? "d-none" : null} align="center" margin="0" mini="true">Por favor, preencha os seus dados para entrarmos em contacto:</SubTitle>*/}
                        <SubTitle align="center" margin="0" mini="true">Por favor, preencha os seus dados para entrarmos em contacto:</SubTitle>
                        {/*<MarginBox className={showForm ? "d-none" : null}>*/}
                        <MarginBox>
                            <OtherContentBox size="100%">
                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Nome</label>
                                    <input id="demoName" type="text" className="form-control" required />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Email</label>
                                    <input id="demoEmail" type="email" className="form-control" required />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Telemóvel</label>
                                    <input id="demoTelemovel" type="tel" className="form-control" required pattern="[0-9]{9}" />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Empresa</label>
                                    <input id="demoEmpresa" type="text" className="form-control" required />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Software de Contabilidade</label>

                                    <select id="demoSoftware" className="form-control" required defaultValue="">
                                        <option style={{ color: "#1b2555" }} value="" disabled>Selecione uma opção</option>
                                        <option style={{ color: "#1b2555" }} value="sage">Sage</option>
                                        <option style={{ color: "#1b2555" }} value="primavera">Primavera</option>
                                        <option style={{ color: "#1b2555" }} value="phc">PHC</option>
                                        <option style={{ color: "#1b2555" }} value="outro">Outro</option>
                                    </select>
                                </div>

                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id="demoCheck" required />
                                    <label className="form-check-label" style={{ color: "#1b2555" }}>
                                        Ao submeter este formulário declara que os dados preenchidos são verdadeiros e aceita que sejam guardados pela Latourrette Consulting | Bizdocs sob finalidade de poder ser contactado por um Parceiro Autorizado das marcas.
                                </label>
                                </div>

                            </OtherContentBox>
                        </MarginBox>
                        {/*
                        <MarginBox className={showForm ? null : "d-none"} >
                            <OtherContentBox size="100%" >
                                <SubTitle align="center" margin="0">
                                    Em breve iremos entrar em contacto para agendar a demonstração e ajudá-lo a poupar tempo, ser mais produtivo e eficaz!
                                </SubTitle>
                                <img style={{ width: "50px", height: "50px", alignSelf: "center", margin: "50px" }} src={BizIcon} alt=""/>
                                <SubTitle align="center" margin="0" mini="true">
                                    Entretanto, <a href="https://bizdocs.mobi/welcome/news">visite o nosso blog</a> ou as nossas redes sociais e fique a par de todas as novidade sobre Contabilidade!
                                </SubTitle>
                            </OtherContentBox>
                        </MarginBox>
                        */}
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center">
                        {/*
                        <Button className={showForm ? "d-none" : null} style={{ backgroundColor: "#6CB93D", color: "#FFFFFF" }} variant="default" onClick={sendEmailForm}>
                            Enviar
                        </Button>
                        */}
                        <Button style={{ backgroundColor: "#6CB93D", color: "#FFFFFF" }} variant="default" onClick={sendEmailForm}>
                            Enviar
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Header bgColor="#6CB93D" />

            
                <MarginBox>
                    <ContentBox showInMobile="true" size="35%">
                        <TextContent>
                            <h1 className="first">
                                <span className="first"> Bem-vindo(a) <br /> ao Arquivo Digital</span> <br /> do Bizdocs
                            </h1>
                            <ImgMobileBox>
                                <Image imageSrc={FirstImage} />
                            </ImgMobileBox>
                            <p>
                            Hoje vai...
                            </p>
                                <TextCheck content="Aumentar a produtividade" />
                                <TextCheck content="Evitar perder tempo" />
                                <TextCheck content="Reduzir custos" />
                                <TextCheck content="Ser mais eficiente" />
                            
                        </TextContent>
                        <TitleLabel align="left" margin="0px 0px 25px">Aceda à sua área de cliente e comece a trabalhar em segundos.</TitleLabel>
                        <GreenButton
                            content="Login"
                            maxWidth="337px"
                            margin="0 10px 0 0" minheight="55px"
                            to='/home' />
                    </ContentBox>
                    <ContentBox size="15%" />
                    <ImgBox showInMobile="false" size="50%">
                        <Image imageSrc={FirstImage} />
                    </ImgBox>
                </MarginBox>
                <MarginBox>
                    <BigGreenBox>
                        <h1 style={{ marginTop: "31px" }}>
                            É cliente <img src={Sage} alt=""/> ?
                        </h1>
                        <h1>
                        Descubra o que já temos preparado para si.
                        </h1>
                        
                        <span className="know-more blue-highlight" onClick={expand}>Clique aqui para saber mais</span>
                        <BizdocsDown className="bounce blue-highlight" onClick={expand} />
                        
                    </BigGreenBox>
                </MarginBox>

                <MarginBox>
                    <BigGreenBox id="greenBoxContent" className="d-none">
                        <h1 style={{ margin: "20px 69px 0 69px" }}>
                            Arquivo Digital Cloud integrado com Sage for Accountants
                        </h1>
                        <p className="description">
                            O add-on <span>Arquivo Digital Cloud</span> ilimitado integrado com o Sage for Accountants permite ao seu escritório de Contabilidade manter-se operacional, seguro e eficiente em qualquer lado onde precise de trabalhar
                        </p>
                        <div className="row mg">

                            <div className="col-lg-4 col-md-4">
                                <div className="d-flex justify-content-center">
                                    <SageIcon1 className="grid-icon" />
                                </div>
                                <p>
                                    <span>Correspondência automática</span> dos documentos digitalizados com os lançamentos do Sage for Accountants – <span>eFatura Connection</span> e importação do <span>SAFT de Venda</span>.
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="d-flex justify-content-center">
                                    <SageIcon2 className="grid-icon" />
                                </div>
                                <p>
                                    <span>Automatização do registo contabilístico</span> com base nos documentos digitalizados para <span>Contabilidade organizada ao dia</span>.
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="d-flex justify-content-center">
                                    <SageIcon3 className="grid-icon-large" />
                                </div>
                                <p>
                                    <span>Importação via Arquivo Digital Cloud</span> para receber documentos existentes no sistema de arquivo digital e lançá-los diretamente na contabilidade.
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="d-flex justify-content-center">
                                    <SageIcon4 className="grid-icon-large" />
                                </div>
                                <p>
                                    <span>Arquivo ilimitado</span> dos documentos de base da contabilidade, para a <span>eliminação de custos</span> arquivos físicos e redução de custos com material de escritório.
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="d-flex justify-content-center">
                                    <SageIcon5 className="grid-icon" />
                                </div>
                                <p>
                                    <span>Acesso disponibilizado aos clientes</span>, a qualquer momento, à documentação contabilística (à qual, de outra forma, não teriam acesso durante meses).
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="d-flex justify-content-center">
                                    <SageIcon6 className="grid-icon-large" />
                                </div>
                                <p>
                                    Conformidade com a legislação de desmaterialização de documentos (<span>DL 28/2019</span>) e proteção de dados pessoais (<span>RGPD</span>).
                                </p>
                            </div>

                        </div>

                        <div className="row mgm">
                            <CarouselSlider
                                slidesToShow={1}
                                slidesToScroll={1}
                                autoplay={true}
                                autoplaySpeed={6000}
                                firstCard={
                                    <div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-center">
                                                <SageIcon1 className="grid-icon" />
                                            </div>
                                            <p>
                                                <span>Correspondência automática</span> dos documentos digitalizados com os lançamentos do Sage for Accountants – <span>eFatura Connection</span> e importação do <span>SAFT de Venda</span>.
                                            </p>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-center">
                                                <SageIcon2 className="grid-icon" />
                                            </div>
                                            <p>
                                                <span>Automatização do registo contabilístico</span> com base nos documentos digitalizados para <span>Contabilidade organizada ao dia</span>.
                                            </p>
                                        </div>
                                    </div>
                                }
                                secondCard={
                                    <div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-center">
                                                <SageIcon3 className="grid-icon-large" />
                                            </div>
                                            <p>
                                                <span>Importação via Arquivo Digital Cloud</span> para receber documentos existentes no sistema de arquivo digital e lançá-los diretamente na contabilidade.
                                            </p>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-center">
                                                <SageIcon4 className="grid-icon-large" />
                                            </div>
                                            <p>
                                                <span>Arquivo ilimitado</span> dos documentos de base da contabilidade, para a <span>eliminação de custos</span> arquivos físicos e redução de custos com material de escritório.
                                            </p>
                                        </div>
                                    </div>
                                }
                                thirdCard={
                                    <div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-center">
                                                <SageIcon5 className="grid-icon" />
                                            </div>
                                            <p>
                                                <span>Acesso disponibilizado aos clientes</span>, a qualquer momento, à documentação contabilística (à qual, de outra forma, não teriam acesso durante meses).
                                            </p>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-center">
                                                <SageIcon6 className="grid-icon-large" />
                                            </div>
                                            <p>
                                                Conformidade com a legislação de desmaterialização de documentos (<span>DL 28/2019</span>) e proteção de dados pessoais (<span>RGPD</span>).
                                            </p>
                                        </div>
                                    </div>
                                }
                            />
                        </div>

                        <div className="row mg d-flex justify-content-center">
                            <BookDemoButton
                                content="Quero marcar uma demonstração"
                                maxWidth="500px"
                                margin="0 0 46px 0" minheight="55px"
                                color="#1B2555"
                                doStuff={handleShow} />
                        </div>
                    </BigGreenBox>
                </MarginBox>
                <StripCenter />
            

            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginBox>
                    <ContentCenterBox size="50%">
                        <TextContent>
                            <h1>
                                Todo o escritório <br />na sua mão
                            </h1>
                            <p>
                                Todos os documentos dos seus clientes guardados e organizados no seu arquivo próprio. Em total segurança.
                            </p>
                        </TextContent>
                    </ContentCenterBox>
                    <ImageBox showInMobile="true" size="50%">
                        <BigImage imageSrc={PC1} />
                    </ImageBox>
                </MarginBox>
            </ScrollAnimation>

            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginBox>
                    <ImageBox showInMobile="true" size="50%">
                        <BigImage imageSrc={PC2} />
                    </ImageBox>
                    <ContentCenterBox size="50%">
                        <TextContent>
                            <h1>
                                Interface Intuitiva
                            </h1>
                            <p>
                                Com dois cliques está tudo ao seu alcance. <br />Sem perder tempo.
                            </p>
                        </TextContent>
                    </ContentCenterBox>
                </MarginBox>
            </ScrollAnimation>

            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginBox>
                    <ContentCenterBox size="50%">
                        <TextContent>
                            <h1>
                                Acesso fácil aos documentos para contabilização
                            </h1>
                            <p>
                                Com ecrãs específicos para documentos por lançar, em processamento e contabilizados para que não restem dúvidas.
                            </p>
                        </TextContent>
                    </ContentCenterBox>
                    <ImageBox showInMobile="true" size="50%">
                        <BigImage imageSrc={PC3} />
                    </ImageBox>
                </MarginBox>
            </ScrollAnimation>

            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginBox>
                    <OtherContentBox size="100%">
                        <TextContent>
                            <h1 className="center">
                                Descubra tudo o que o <span className="first">Arquivo Digital</span> do Bizdocs <span className="first">faz por si </span>
                            </h1>
                        </TextContent>
                    </OtherContentBox>
                </MarginBox>
                <CardsBox items={cards} />
                <StripCenter />
            </ScrollAnimation>

            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginBox>
                    <GreenButton
                        content="Aceda à sua área de cliente"
                        maxWidth="500px"
                        margin="10vh auto" width="337px" to='/home' />
                </MarginBox>
            </ScrollAnimation>
            <DesktopFooter />
            <MobileFooter bgColor="#6CB93D" />
        </>
    );
});

export default function DigitalArchive() {
    return (
        <Suspense fallback={<Loader />}>
            <DigitalArchiveConst />
        </Suspense>
    );
}